export const headerData = [
  // {
  //   type: "checkbox",
  //   text: ""
  // },
  // {
  //   text: "",
  // },
  {
    text: "ID",
  },
  {
    text: "Title",
  },
  // {
  //   text: "SKU",
  // },
  // {
  //   text: "Description",
  // },
  // {
  //   text: "",
  // },
];

export const footerData = {
  title: "No record found",
  subTtitle: "No such category exists. Create one?",
  imgSrc: "../../../assets/no-search-found.svg",
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  // {
  //   key: "isChecked",
  //   type: "checkbox",
  // },
  // {
  //   key: "categoryGlobalImage",
  //   type: "img",
  // },
  {
    key: "categoryGlobalHandle",
    type: "",
  },
  {
    key: "categoryGlobalTitle",
    type: "",
  },
  // {
  //   key: "categoryHandle",
  //   type: "",
  // },
  // {
  //   key: "categoryDescription",
  //   type: "",
  // },
  {
    key: "isEnabled",
    type: "",
  },
];
